var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-renderer"},[_c('div',{ref:"container",staticClass:"app-scene"}),_c('div',{staticClass:"helpers absolute z-10 right-0 top-0 p-0"})])}
var staticRenderFns = []

export { render, staticRenderFns }